import type { WSMessage } from './types';

type DoorOpeningMessage = Extract<WSMessage, { type: 'ft3d_door_opening' }>;

function handleFt3dDoorOpening(data: DoorOpeningMessage): void {
    if (data.schema !== 'ft.ft3d.door-opening.v1'
        || !checkIfValidUUID(data.encounter_id)
        || typeof data.opening_id !== 'string'
        || data.opening_id.trim() === ''
        || data.opening_id.length > 191
        || !['move', 'resize', 'delete'].includes(data.operation)
        || (data.operation === 'delete' ? data.opening !== null : !data.opening || typeof data.opening !== 'object')) return;
    window.dispatchEvent(new CustomEvent('ft:ft3d-door-opening', { detail: data }));
}

export { handleFt3dDoorOpening };
